import { render, staticRenderFns } from "./small.vue?vue&type=template&id=067df7d6"
import script from "./small.vue?vue&type=script&lang=js"
export * from "./small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports